const Theme = {
  card_background_color: '#3b2122',

  header_background_color: '#3b2122',
  header_full_height: true,
  logo_image_url: 'bateaufantome.png',

  body_background_color: '#3b2122',
  button_color: '#b43028',
  button_half_border_color: '#c1322b',

  text_font: `'Open Sans', sans-serif`,
  text_color: 'white',
  title_font: `'Open Sans', sans-serif`,
  title_weight: 400,

  popup_text_color: 'black',
}

export default Theme
